import React from "react";
import {
  FaCode,
  FaServer,
  FaDatabase,
  FaCloud,
  FaTools,
  FaCertificate,
  FaAws,
  FaDocker,
  FaGitAlt,
  FaLinux,
  FaReact,
  FaNodeJs,
} from "react-icons/fa";
import {
  SiTypescript,
  SiPython,
  SiGo,
  SiCplusplus,
  SiPostgresql,
  SiRedis,
  SiKubernetes,
  SiTerraform,
  SiGithubactions,
  SiGrafana,
  SiPrometheus,
  SiGnubash,
  SiPostman,
  SiPytorch,
} from "react-icons/si";

function Skills() {
  const skillCategories = [
    {
      icon: FaCode,
      title: "Programming Languages",
      skills: [
        { name: "Python", Icon: SiPython },
        { name: "TypeScript", Icon: SiTypescript },
        { name: "Go", Icon: SiGo },
        { name: "C++ / CUDA", Icon: SiCplusplus },
        { name: "SQL", Icon: null },
        { name: "Shell", Icon: SiGnubash },
      ],
    },
    {
      icon: FaCloud,
      title: "DevOps & Cloud",
      skills: [
        { name: "AWS", Icon: FaAws },
        { name: "Kubernetes", Icon: SiKubernetes },
        { name: "Docker", Icon: FaDocker },
        { name: "Terraform", Icon: SiTerraform },
        { name: "GitHub Actions", Icon: SiGithubactions },
        { name: "Prometheus", Icon: SiPrometheus },
        { name: "Grafana", Icon: SiGrafana },
        { name: "OpenTelemetry", Icon: null },
        { name: "CI/CD", Icon: null },
      ],
    },
    {
      icon: FaServer,
      title: "AI & Backend",
      skills: [
        { name: "FastAPI", Icon: null },
        { name: "LangGraph", Icon: null },
        { name: "LangChain", Icon: null },
        { name: "PyTorch", Icon: SiPytorch },
        { name: "vLLM", Icon: null },
        { name: "Node.js", Icon: FaNodeJs },
        { name: "React", Icon: FaReact },
      ],
    },
    {
      icon: FaDatabase,
      title: "Databases",
      skills: [
        { name: "PostgreSQL", Icon: SiPostgresql },
        { name: "Redis", Icon: SiRedis },
        { name: "pgvector", Icon: null },
        { name: "MySQL", Icon: null },
      ],
    },
    {
      icon: FaTools,
      title: "Tools",
      skills: [
        { name: "Git", Icon: FaGitAlt },
        { name: "Linux", Icon: FaLinux },
        { name: "Postman", Icon: SiPostman },
        { name: "Trivy", Icon: null },
        { name: "CodeQL", Icon: null },
        { name: "Rancher", Icon: null },
      ],
    },
  ];

  const certifications = [
    {
      name: "Certified Kubernetes Application Developer (CKAD)",
      issuer: "CNCF",
      Icon: SiKubernetes,
    },
  ];

  return (
    <div className="skills-section">
      <div className="resume-divider"></div>

      <div className="skills-categories">
        {skillCategories.map((category, idx) => (
          <div key={idx} className="skill-category-block">
            <div className="skill-category-header">
              <category.icon className="skill-category-icon" />
              <h3>{category.title}</h3>
            </div>
            <div className="skill-pills">
              {category.skills.map((skill, sIdx) => (
                <span key={sIdx} className="skill-pill">
                  {skill.Icon && <skill.Icon className="skill-pill-icon" />}
                  {skill.name}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Certifications */}
      <div className="skill-category-block certifications-block">
        <div className="skill-category-header">
          <FaCertificate className="skill-category-icon" />
          <h3>Certifications</h3>
        </div>
        <div className="certifications-list">
          {certifications.map((cert, idx) => (
            <div key={idx} className="certification-card">
              <cert.Icon className="certification-icon" />
              <div className="certification-info">
                <span className="certification-name">{cert.name}</span>
                <span className="certification-issuer">{cert.issuer}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;
